// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3TjEq","icon":"styles_icon__1GTzA"};